import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer({ isHomePage = false }) {
  const { t } = useTranslation();
  const copyright = isHomePage
    ? t('home.copyright')
    : t('footer.copyrightDesktop');
  
  return (
    <footer className={`footer${isHomePage ? ' footer-home' : ''}`}>
      <div className="footer-container">
        <div className="footer-left">
          <img src={isHomePage ? '/assets/home/company-logo.svg' : '/assets/company-logo.svg'} alt="Company Logo" className="footer-logo" />
          <p className="copyright">{copyright}</p>
        </div>
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">{t('footer.privacy')}</Link>
          <Link to="/terms" className="footer-link">{t('footer.termsOfUse')}</Link>
          <a href={t('links.support')} className="footer-link">{t('footer.support')}</a>
          <a href={t('links.followUs')} className="footer-link">{t('footer.followUs')}</a>
        </div>
        <p className="copyright copyright-mobile">{isHomePage ? copyright : t('footer.copyrightMobile')}</p>
      </div>
    </footer>
  );
}

export default Footer;
